import { useQuery } from 'react-query';

import {
  ARTICLE_SHARE_KEY,
  ArticleShareResponse,
  getArticleShareLink,
} from '@utils/backend-api/articles';

export default function useArticleShareLink({ articleId }: { articleId: number }) {
  const { data: articleShare, isLoading: isArticleShareLoading } = useQuery<ArticleShareResponse>(
    [ARTICLE_SHARE_KEY, articleId],
    () => getArticleShareLink({ articleId })
  );

  return { articleShare, isArticleShareLoading };
}
